import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { CadastroPage } from './cadastro.page';
import { CadastroModel } from 'projects/core/src/lib/core/model/CadastroModel';
import { validate } from 'projects/core/src/lib/core/ValidateCPF'
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { UsuarioProvider } from 'projects/core/src/lib/core/provider/UsuarioProvider';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { LoginModel } from 'projects/core/src/lib/core/model/LoginModel';
import { TokenModel } from 'projects/core/src/lib/core/model/TokenModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { FirebaseWrapper } from 'projects/core/src/lib/core/FirebaseWrapper';
import { NotificacoesModel } from 'projects/core/src/lib/core/model/NotificacoesModel';

export class CadastroViewModel {

    notificacoesModel: NotificacoesModel

    constructor() {
        this.notificacoesModel = new NotificacoesModel()
    }

    cadastroModel = new CadastroModel()
    context: CadastroPage
    loginModel = new LoginModel()
    usuarioModel = new UsuarioModel()
    usuarioProvider = new UsuarioProvider()

    setContext(context: CadastroPage) {
        this.context = context
    }

    getContext(): CadastroPage {
        return this.context
    }

    async enviaCadastro(cadastroModel: CadastroModel) {
        let cadastroModelAux: any = {}
        cadastroModelAux.name = cadastroModel.name
        cadastroModelAux.email = cadastroModel.email.toLocaleLowerCase().trim()
        cadastroModelAux.cpf = this.limpaCaracteresCpf(cadastroModel.cpf)
        cadastroModelAux.password = cadastroModel.password
        cadastroModelAux.passwordConfirm = cadastroModel.passwordConfirm
        cadastroModelAux.phone = cadastroModel.phone

        const retorno = await this.cadastroModel.enviaCadastro(cadastroModelAux)
        if (retorno.status == ResponseModel.STATUS_OK) {
            this.loginModel.usuario = cadastroModelAux.cpf
            this.loginModel.senha = cadastroModelAux.password

            await this.processoLogin();
            await this.processoObtemInformacoesUsuario()
            //await this.configuraTopicsFirebase();

            this.getContext().mensagemSucessoAlteracao('Cadastro realizado com sucesso!')
        } else {
            if (typeof retorno.data.error == "string") {
                this.getContext().mensagemFalhaAlteracao(retorno.data.error)
            } else {
                this.getContext().mensagemFalhaAlteracao(retorno.data.error.cpf[0])
            }
        }
    }

    async processoLogin() {
        const retorno = await this.loginModel.loginUsuario(this.loginModel);
        console.log('1, ',JSON.stringify(retorno))
        if (retorno.status == ResponseModel.STATUS_OK) {
            this.criaSessaoToken(retorno.data)
        } else {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async processoObtemInformacoesUsuario() {
        const retorno = await this.usuarioProvider.informacoesUsuario();
        console.log(JSON.stringify(retorno))
        if (retorno.status == ResponseModel.STATUS_OK) {
            this.criaSessaoUsuario(retorno.data)
        } else {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    configuraTopicsFirebase() {
        new FirebaseWrapper().configuraTopicsFirebase(this.notificacoesModel)
    }

    criaSessaoToken(tokenModel: TokenModel) {
        AppSession.saveToken(tokenModel);
    }

    validateCpf(cpf) {
        return validate(this.limpaCaracteresCpf(cpf))
    }

    limpaCaracteresCpf(texto: String) {
        return texto.replace(/[.-]/gi, '')
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase().trim());
    }

    criaSessaoUsuario(usuarioModel: UsuarioModel) {
        AppSession.saveUser(usuarioModel);
    }
}